import { render, staticRenderFns } from "./TabelaCalculo.vue?vue&type=template&id=648d31d7&"
import script from "./TabelaCalculo.vue?vue&type=script&lang=js&"
export * from "./TabelaCalculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports